import InvoiceIcon from "@dana/Icons/InvoiceIcon";
import { themeColors } from "@dana/MobiusOverrides/styles/colors";
import { fontWeights } from "@dana/MobiusOverrides/styles/typography";
import { orderHistoryTableStyles } from "@dana/Overrides/Widgets/OrderHistory/OrderHistoryTable";
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { StyledClickable, StyledTypography } from "@insite/mobius/Link";
import { css } from "styled-components";

orderHistoryTableStyles.reorderButton = mergeToNew(orderHistoryTableStyles.reorderButton, {
    color: themeColors.primary.danaBlue,
});

orderHistoryTableStyles.orderDateCells = mergeToNew(orderHistoryTableStyles.orderDateCells, {
    css: css`
        padding: 16px;
    `,
});

orderHistoryTableStyles.orderNumberCells = mergeToNew(orderHistoryTableStyles.orderNumberCells, {
    css: css`
        padding: 16px;

        ${StyledClickable} {
            &:hover {
                text-decoration: none;
            }
        }

        ${StyledTypography} {
            font-weight: ${fontWeights.semiBold};
            text-decoration: none;
        }

        .process-no {
            display: block;
            margin-top: 4px;
        }
    `,
});

orderHistoryTableStyles.shipToCells = mergeToNew(orderHistoryTableStyles.shipToCells, {
    css: css`
        padding: 16px;
    `,
});

orderHistoryTableStyles.statusCells = mergeToNew(orderHistoryTableStyles.statusCells, {
    css: css`
        padding: 16px;
    `,
});

orderHistoryTableStyles.customerPOCells = mergeToNew(orderHistoryTableStyles.customerPOCells, {
    css: css`
        padding: 16px;
    `,
});

orderHistoryTableStyles.orderTotalCells = mergeToNew(orderHistoryTableStyles.orderTotalCells, {
    alignX: "left",
    css: css`
        padding: 16px;
    `,
});

orderHistoryTableStyles.reorderCells = mergeToNew(orderHistoryTableStyles.reorderCells, {
    css: css`
        padding: 16px;
    `,
});

orderHistoryTableStyles.checkboxCells = mergeToNew(orderHistoryTableStyles.checkboxCells, {
    css: css`
        padding: 16px;
    `,
});

orderHistoryTableStyles.invoicesButtons = mergeToNew(orderHistoryTableStyles.invoicesButtons, {
    css: css`
        margin-top: 16px;
        display: flex;
        align-items: center;
        gap: 16px;
    `,
});

orderHistoryTableStyles.invoiceButton = mergeToNew(orderHistoryTableStyles.invoiceButton, {
    icon: {
        src: InvoiceIcon,
        position: "left",
        size: 14,
    },
    variant: "secondary",
    typographyProps: {
        size: 14,
    },
    css: css`
        padding: 8px;
    `,
});


orderHistoryTableStyles.container =  mergeToNew(orderHistoryTableStyles.container, {
    css: css`
        position: relative;
    `,
});
